import { Asterisk } from "lucide-react";

const ITEMS = [
  "Konstruksi Bangunan",
  "Renovasi Rumah & Gedung",
  "Desain & Pembangunan",
  "Pekerjaan Interior",
  "Pemeliharaan & Perbaikan",
  "Konsultasi Proyek",
];

export const Marquee = () => {
  const row = (ariaHidden) => (
    <div
      aria-hidden={ariaHidden}
      className="flex shrink-0 items-center"
    >
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-heading text-lg font-bold uppercase tracking-[0.18em] text-white/90 sm:text-xl">
            {item}
          </span>
          <Asterisk className="h-5 w-5 shrink-0 text-orange-500" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-navy-dark py-5"
      aria-label="Daftar layanan berjalan"
    >
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
